import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SnackBarComponent } from './snack-bar.component';
import { MatSnackBarModule, MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from '@shared/forms/elements/button/button.module';

@NgModule({
  declarations: [SnackBarComponent],
  exports: [SnackBarComponent, TranslateModule, ButtonModule],
  imports: [
    CommonModule,
    MatSnackBarModule,
    TranslateModule,
    ButtonModule
  ],
  providers: [
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: {
        duration: 1500,
        horizontalPosition: 'right',
        verticalPosition: 'bottom'
      }
    }
  ]
})
export class SnackBarModule { }
